import { CompetitionIntensityModel } from "../models/CompetitionIntensityModel";
import API, { client } from "./API";

const CompetitionIntensityService = {
  async getAllCompetitionIntensities() {
    const response = await API().get("ProjectCompetitionIntensity", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularCompetitionIntensity(ci_id: number) {
    const response = await API().get("CompetitionIntensity");
    return response.data.filter(
      (cur_ci: CompetitionIntensityModel) =>
        cur_ci.competitionIntensityId === ci_id
    )[0];
  },
  async createCompetitionIntensity(
    data: CompetitionIntensityModel,
    id?: number
  ) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id
          ? `ProjectCompetitionIntensity/${id}`
          : "ProjectCompetitionIntensity",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default CompetitionIntensityService;
